import { Link } from "react-router-dom";
import Modal from "react-modal";
import {ReactComponent as ConfirmSvg} from '../../../media/confirm.svg';
import "../../../styles/Containers.css"

export default function ConfirmDelete ({showCModal, handleCloseCModal, handleDeleteList}) {
    return <Modal
    isOpen={showCModal}
    onRequestClose={handleCloseCModal}
    className="modal"
    overlayClassName="overlay"
    >
    <div className="modal-header">
      <ConfirmSvg className="marginR30 marginTop5" alt="confirm"></ConfirmSvg>
    </div>
    <div className="modal-body">
      <h2>
     برای حذف این لیست خرید مطمئن هستی؟ </h2>
      <p className="yekan grey-2 caption-1 paddingButtom5">
     بعدا میتونی دوباره ایجادش کنی.</p>
    </div>
    <div className="modal-footer">
      <Link
        to=""
        onClick={handleDeleteList}
        className="marginBottom0-4r fill-container b-red-1 radius1-5"
      >
        آره حدف کن
      </Link>
      <Link
        to=""
        onClick={handleCloseCModal}
        className="b-grey-4 grey-1 fill-container radius1-5"
      >
        منصرف شدم
      </Link>
    </div>
    </Modal>
}


